module.exports = __webpack_public_path__ + "static/img/8.6667c03b.png";